// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_FEED_POST = "P\u0159idej diskuzi";
export const SEO_DESCRIPTION_FORUM = "Diskuzn\u00ed m\u00edsto pro maminky pln\u00e9 zku\u0161enost\u00ed, rad, tip\u016f a trik\u016f p\u0159\u00edmo z prvn\u00ed ruky. M\u00edsto ka\u017edodenn\u00edch radost\u00ed a starost\u00ed, kter\u00e9 nen\u00ed o ide\u00e1ln\u00edch mamink\u00e1ch, ale o skute\u010dn\u00e9m \u017eivot\u011b.";
export const SEO_TITLE_FORUM = "F\u00f3ra";
export const TAB_FORUMS = "F\u00f3ra";
export const TAB_GROUPS = "Skupiny";
